export default function setAgentMapCenter({ state }, { lat, lng }) {
  state.set(['agentMapView', 'mapChanged'], true);
  state.set(['agentMapView', 'mapCenter'], { lat, lng });
}
